export default __webpack_public_path__ + "static/media/cp_geo_tk.935191a1.svg";